import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import type { AgencyMembership } from 'modules/core/types';
import { UserTitle } from 'components';
import { ControlledTableColumns } from 'components/ControlledTable';

export const columns: ControlledTableColumns<AgencyMembership> = [
  {
    content: 'User',
    key: 'user',
    required: true,
    cellProps: {
      className: 'py-1',
    },
    render: ({ id, user }: AgencyMembership): ReactElement => (
      <Link to={`${id}`}>
        <UserTitle {...user} />
      </Link>
    ),
  },
  {
    content: 'Groups',
    key: 'groups',
    cellProps: {
      className: 'align-middle',
    },
    render: ({ groups }) => groups.map(({ name }) => name).join(', '),
  },
];
